var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('UserActivity',{attrs:{"active":_vm.active}}),_vm._v(" "),(_vm.getUsersWithLocation.length > 0)?_c('Geographics',{attrs:{"users":_vm.getUsersWithLocation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }